import axios from 'axios'
import store from '../store'

export const API = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL + process.env.VUE_APP_BASE_API_VERSION
})

API.interceptors.request.use(config => {
  store.commit('setLoading', true);
  const token = store.getters['fullToken']
  if (token) config.headers.Authorization = token
  return config
})

API.interceptors.response.use(
  response => {
    return response
  },
  error => {
    const errorMessage = error.response.data.msg || error.toString();
    store.dispatch('error', errorMessage);
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.dispatch('clearStore');
          window.location.href = '/login';
          break;
        case 403:
          store.dispatch('clearStore');
          window.location.href = '/login';
          break;
        default:
          if (process.env.NODE_ENV !== 'production') {
            console.log(`Status code: ${error.response.status}\n${(error.response.data && error.response.data.message) || 'Unknown.\nNo Response Data.'}`)
          }
      }
    } else {
      console.log('Unknown Error', error)
    }
    return Promise.reject(error)
  }
)

export default axios
